import { render, staticRenderFns } from "./label-dynamic-filter.vue?vue&type=template&id=46f883b1&lang=pug"
import script from "./label-dynamic-filter.vue?vue&type=script&lang=js"
export * from "./label-dynamic-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports